// extracted by mini-css-extract-plugin
module.exports = {"panel":"Hook_panel___JQqX","content":"Hook_content__mcp6q","info":"Hook_info__6ec89","title":"Hook_title__tnLDk","sub":"Hook_sub__7jmTb"};